// eslint-disable-next-line simple-import-sort/imports
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// Подключение шрифта
import '@mes-ui/lemma/styles/font.css';
// Переменные: типографика, цвета, тени
import '@mes-ui/lemma/styles/allVariables.css';
// Миксин для скрола
import '@mes-ui/lemma/styles/mixins.scss';
// Миксин стилей текста
import '@mes-ui/lemma/styles/typographyMixin.scss';
import store from 'store';
import App from 'portfolio3/App';

import * as serviceWorker from './serviceWorker';

import './index.scss';

// auth token for a local development
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_AUPD_TOKEN) {
  document.cookie = `aupd_token=${process.env.REACT_APP_AUPD_TOKEN}; path=/`;
  document.cookie = `aupd_current_role=${process.env.REACT_APP_AUPD_CURRENT_ROLE}; path=/`;
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
